module.exports = __webpack_public_path__ + "static/media/pochend.d466f10f.jpg";